import { createAction } from '@reduxjs/toolkit'

type ActionName = string

/**
 * The system error page has mounted.
 */
export const systemErrorPageLoad = createAction('systemErrorPageLoad')

export const GET_DEMOGRAPHIC_INFO: ActionName = 'GET_DEMOGRAPHIC_INFO'
export const GET_DEMOGRAPHIC_CHILD_INFO: ActionName =
  'GET_DEMOGRAPHIC_CHILD_INFO'
export const SET_ACTIVE_ACCOUNT_INFO: ActionName = 'SET_ACTIVE_ACCOUNT_INFO'
export const UPDATE_DEMOGRAPHIC_INFO_STATE: ActionName =
  'UPDATE_DEMOGRAPHIC_INFO_STATE'
export const UPDATE_INVOICE_STATE: ActionName = 'UPDATE_INVOICE_STATE'
export const UPDATE_CARD_INFO_STATE: ActionName = 'UPDATE_CARD_INFO_STATE'
export const SET_SELECTED_ACCOUNT: ActionName = 'SET_SELECTED_ACCOUNT'
export const SET_PAYMENT_DATE: ActionName = 'SET_PAYMENT_DATE'
export const UPDATE_UNAPPLIED_PAYMENTS: ActionName = 'UPDATE_UNAPPLIED_PAYMENTS'
export const SET_CONFIRMATION_EMAIL: ActionName = 'SET_CONFIRMATION_EMAIL'
export const SET_TOTAL_PAYMENT_AMOUNT: ActionName = 'SET_TOTAL_PAYMENT_AMOUNT'
export const GET_PAYMENT_LIST: ActionName = 'GET_PAYMENT_LIST'
export const GET_ONE_TIME_PAYMENT_LIST: ActionName = 'GET_ONE_TIME_PAYMENT_LIST'
export const UPDATE_PAYMENT_LIST: ActionName = 'UPDATE_PAYMENT_LIST'
export const EDIT_PAYMENT_INFO: ActionName = 'EDIT_PAYMENT_INFO'
export const PAYMENT_LIST_FAILURE: ActionName = 'PAYMENT_LIST_FAILURE'
export const GET_CHILD_ACCOUNT_SUCCESS: ActionName = 'GET_CHILD_ACCOUNT_SUCCESS'
export const GET_CHILD_ACCOUNT_FAILURE: ActionName = 'GET_CHILD_ACCOUNT_FAILURE'
export const GET_AUTH_TOKEN: ActionName = 'GET_AUTH_TOKEN'
export const GET_REFRESH_TOKEN: ActionName = 'GET_REFRESH_TOKEN'
export const UPDATE_AUTH_TOKEN_STATE: ActionName = 'UPDATE_AUTH_TOKEN_STATE'
export const GET_PAYMENT_ACCOUNT_LIST: ActionName = 'GET_PAYMENT_ACCOUNT_LIST'
export const ADD_PAYMENT_ACCOUNT: ActionName = 'ADD_PAYMENT_ACCOUNT'
export const ADD_PAYMENT_ACCOUNT_SUCCESS: ActionName =
  'ADD_PAYMENT_ACCOUNT_SUCCESS'
export const ADD_PAYMENT_ACCOUNT_FAILURE: ActionName =
  'ADD_PAYMENT_ACCOUNT_FAILURE'
export const ADD_PAYMENT_ACCOUNT_RESET: ActionName = 'ADD_PAYMENT_ACCOUNT_RESET'
export const DELETE_PAYMENT_ACCOUNT: ActionName = 'DELETE_PAYMENT_ACCOUNT'
export const UPDATE_PAYMENT_ACCOUNT_STATE: ActionName =
  'UPDATE_PAYMENT_ACCOUNT_STATE'
export const LOGGED_OUT: ActionName = 'LOGGED_OUT'
export const GET_BUYER_LIST: ActionName = 'GET_BUYER_LIST'
export const ADD_BUYER: ActionName = 'ADD_BUYER'
export const ADD_BUYER_RESET: ActionName = 'ADD_BUYER_RESET'
export const DELETE_BUYER: ActionName = 'DELETE_BUYER'
export const ORDER_REPLACEMENT_CARDS: ActionName = 'ORDER_REPLACEMENT_CARDS'
export const UPDATE_BUYER_STATE: ActionName = 'UPDATE_BUYER_STATE'
export const RESET_BUYER_STATE: ActionName = 'RESET_BUYER_STATE'
export const UPDATE_CSR_ACCOUNT: ActionName = 'UPDATE_CSR_ACCOUNT'
export const UPDATE_CSR_ACCOUNT_STATE: ActionName = 'UPDATE_CSR_ACCOUNT_STATE'
export const GET_BUSINESS_INFO: ActionName = 'GET_BUSINESS_INFO'
export const UPDATE_BUSINESS_INFO: ActionName = 'UPDATE_BUSINESS_INFO'
export const UPDATE_BUSINESS_INFO_STATE: ActionName =
  'UPDATE_BUSINESS_INFO_STATE'
export const GET_PAYMENT_DETAIL: ActionName = 'GET_PAYMENT_DETAIL'
export const GET_PAYMENT_DETAIL_SUCCESS: ActionName =
  'GET_PAYMENT_DETAIL_SUCCESS'
export const GET_PAYMENT_DETAIL_FAILURE: ActionName =
  'GET_PAYMENT_DETAIL_FAILURE'
export const UPDATE_PO_JOB_NAMES: ActionName = 'UPDATE_PO_JOB_NAMES'
export const UPDATE_PO_JOB_NAMES_RESET: ActionName = 'UPDATE_PO_JOB_NAMES_RESET'
export const UPDATE_PO_JOB_NAMES_STATE: ActionName = 'UPDATE_PO_JOB_NAMES_STATE'
export const CANCEL_PAYMENT: ActionName = 'CANCEL_PAYMENT'
export const CANCEL_ONE_TIME_PAYMENT: ActionName = 'CANCEL_ONE_TIME_PAYMENT'
export const CANCEL_PAYMENT_SUCCESS: ActionName = 'CANCEL_PAYMENT_SUCCESS'
export const CANCEL_PAYMENT_FAILURE: ActionName = 'CANCEL_PAYMENT_FAILURE'
export const GET_PAYMENT_METHOD: ActionName = 'GET_PAYMENT_METHOD'
export const GET_PAYMENT_METHOD_SUCCESS: ActionName =
  'GET_PAYMENT_METHOD_SUCCESS'
export const GET_PAYMENT_METHOD_FAILURE: ActionName =
  'GET_PAYMENT_METHOD_FAILURE'
export const UPDATE_PAYMENT_METHOD_STATE: ActionName =
  'UPDATE_PAYMENT_METHOD_STATE'
export const ONE_TIME_PAYMENT: ActionName = 'ONE_TIME_PAYMENT'
export const EDIT_PAYMENT: ActionName = 'EDIT_PAYMENT'
export const EDIT_ONE_TIME_PAYMENT: ActionName = 'EDIT_ONE_TIME_PAYMENT'
export const SCHEDULE_ONE_TIME_PAYMENT: ActionName = 'SCHEDULE_ONE_TIME_PAYMENT'
export const UPDATE_ONE_TIME_PAYMENT_STATE: ActionName =
  'UPDATE_ONE_TIME_PAYMENT_STATE'
export const UPDATE_PAYMENT_STATE: ActionName = 'UPDATE_PAYMENT_STATE'
export const GET_INVOICE_INFO: ActionName = 'GET_INVOICE_INFO'
export const UPDATE_DOWNLOAD_INVOICE_STATE: ActionName =
  'UPDATE_DOWNLOAD_INVOICE_STATE'
export const GET_USER_ID = 'GET_USER_ID'
export const UPDATE_RECOVER_USER_ID_STATE = 'UPDATE_RECOVER_USER_ID_STATE'
export const GET_PAYMENT_TRANSACTIONS = 'GET_PAYMENT_TRANSACTIONS'
export const UPDATE_EBILL_ENROLLMENT = 'UPDATE_EBILL_ENROLLMENT'
export const UPDATE_EBILL_PROFILE = 'UPDATE_EBILL_PROFILE'
export const UPDATE_EBILL_STATE = 'UPDATE_EBILL_STATE'
export const UPDATE_AUTHORIZE_PAYMENT_STATE = 'UPDATE_AUTHORIZE_PAYMENT_STATE'
export const GET_ONLINE_USER = 'GET_ONLINE_USER'
export const GET_ONLINE_USER_DETAIL = 'GET_ONLINE_USER_DETAIL'
export const UPDATE_ONLINE_USER = 'UPDATE_ONLINE_USER'
export const UPDATE_ONLINE_USER_PRIVILEGE = 'UPDATE_ONLINE_USER_PRIVILEGE'
export const GET_AUTO_PAYMENT_STATE = 'GET_AUTO_PAYMENT_STATE'
export const UPDATE_TRANSACTIONS_STATE: ActionName = 'UPDATE_TRANSACTIONS_STATE'
export const UPDATE_SCHEDULE_TRANSACTIONS = 'UPDATE_SCHEDULE_TRANSACTIONS'
export const GET_AUTO_PAYMENT_LIST: ActionName = 'GET_AUTO_PAYMENT_LIST'
export const UPDATE_REDUX_STATE: ActionName = 'UPDATE_REDUX_STATE'
